import { render, staticRenderFns } from "./AssignedAccounts.vue?vue&type=template&id=fa3a99dc"
import script from "./AssignedAccounts.vue?vue&type=script&lang=js"
export * from "./AssignedAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports